import Index from '@/views/exhibitor/vis/Index.vue';
// import Top from '@/views/exhibitor/brand/Top.vue';
// import New from '@/views/exhibitor/brand/New.vue';
// import Edit from '@/views/exhibitor/brand/Edit.vue';
import Exhibition from '@/views/exhibitor/vis/Exhibition.vue';
import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    path: 'vis',
    component: Index,
    children: [
      {
        name: 'exhibitor-vis-exhibition',
        path: 'exh/:exhibitionId/o/:offlineId/d/:dayId',
        component: Exhibition,
        meta: {
          title: 'オンライン展示会',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
      // {
      //   name: 'exhibitor-brand-top',
      //   path: '',
      //   component: Top,
      //   meta: {
      //     title: 'ブランド詳細',
      //     actor: actors.exhibitor,
      //     auth: auths.required,
      //   },
      // },
      // {
      //   name: 'exhibitor-brand-new',
      //   path: 'new',
      //   component: New,
      //   meta: {
      //     title: '新規作成',
      //     actor: actors.exhibitor,
      //     auth: auths.required,
      //   },
      // },
      // {
      //   name: 'exhibitor-brand-edit',
      //   path: 'edit',
      //   component: Edit,
      //   meta: {
      //     title: '編集',
      //     actor: actors.exhibitor,
      //     auth: auths.required,
      //   },
      // },
    ],
  },
];

export default {
  routes,
};
